import { isSyntheticsTest } from '@datadog/browser-core';
import type { LogsEvent } from '@datadog/browser-logs';

/**
 * 外形監視（Datadog Synthetics browser test）由来のログに印を付ける。
 *
 * RUM SDK は同じ判定で session.type に synthetics を入れるが、Logs SDK は印を付けない。
 * そのため Log Explorer では外形監視のログと人のアクセスのログを区別できず、
 * フロントエンドのエラー調査で監視由来のログが混ざる。
 * RUM と属性名を揃えているので、どちらの Explorer でも @session.type:synthetics で引ける。
 */
const markSyntheticsSession = (log: LogsEvent): void => {
  if (!isSyntheticsTest()) {
    return;
  }
  log.session = { ...log.session, type: 'synthetics' };
};

export { markSyntheticsSession };
